import { IRequestState, IStoreParams } from './models/interfaces';
import { KindsLanguage } from './models/enums';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 1;
export const DEFAULT_PAGE_LIST_SIZE = 20;
export const defaultProgressState: IRequestState = {
  empty: false,
  error: false,
  fetching: true,
};

export const NOTIFICATION_COLORS = {
  success: {
    backgroundColor: '#8CC152',
    backgroundHoverColor: '#8CC152',
    color: '#FFFFFF',
    fontFamily: 'Open Sans, Arial, sans-serif',
  },
  error: {
    backgroundColor: '#FD5555',
    backgroundHoverColor: '#FD5555',
    color: '#FFFFFF',
    fontFamily: 'Open Sans, Arial, sans-serif',
  },
};

export const defaultStoreParams: IStoreParams = {
  requestProgress: defaultProgressState,
  pager: {
    page: DEFAULT_PAGE,
    count: DEFAULT_PAGE_LIST_SIZE,
    total: 0,
  },
  sortCriteria: null,
};

export const LANG = {
  prodMode: true,
  availableLangs: Object.values(KindsLanguage),
  defaultLang: KindsLanguage.en,
  fallbackLang: KindsLanguage.en,
};
